import { render, staticRenderFns } from "./TestSummary.vue?vue&type=template&id=7be47a3b"
import script from "./TestSummary.vue?vue&type=script&lang=js"
export * from "./TestSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports